// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".click-through[data-v-42e6434f]{pointer-events:none}.staff[data-v-42e6434f]{fill:transparent;border:1px solid #000}.staff[data-v-42e6434f],.staff.show-line[data-v-42e6434f]{transition:fill .2s linear}.staff.show-line[data-v-42e6434f]{fill:#0000000a}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
